import React, { useEffect, useRef, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useFormik } from 'formik'
import Swal from 'sweetalert2'
import { SWAL_SETTINGS, ROLE, NOTIFICATION_INTERVAL, WORKOUT_CATEGORY, WORKOUT_PLAN, MEDICINE_OPTIONS } from '../../../../utils/Constants'
import { handleServerValidations, capitalizeFirstLetter, getDateWithTime } from '../../../../utils/commonfunction'
import Skeleton from 'react-loading-skeleton'
import { createPrescription } from '../../services/patient.services'
import { getAllMedicine } from '../../../admin/services/medicine.services'
import * as Yup from 'yup';
import { DatePicker, TagPicker, Tooltip, Whisper } from 'rsuite'
import ChiefComplaintInput from '../../../../utils/ChiefComplaintInput'
import MedicineSelect from '../../../../utils/MedicineSelect'

export default function PrescriptionCreate() {
    const { t } = useTranslation()
    const [defaultData, setDefaultData] = useState({});
    const fileSelectInput = useRef();
    const [loader, setLoader] = useState(true);
    const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
    const location = useLocation();
    const [medicineData, setMedicineData] = useState([]);
    const navigate = useNavigate();

    const prescriptionValidationSchema = Yup.object().shape({
        symptoms: Yup.array().of(Yup.string().required()).min(1, 'At least one symptom is required'),
        // symptoms: Yup.string().trim().required('Chief complaint is required'),
        // diagnosis_notes: Yup.string().trim().required('Diagnosis is required'),
        // past_medical_history: Yup.string().trim().required('Past medical history is required'),
        // investigation_advise: Yup.string().trim().required('Investigation advice is required'),
        // follow_up_date: Yup.date().required('Follow up date is required'),
        // follow_up_date: Yup.date()
        //     .nullable()
        //     .transform((curr, orig) => (orig === '' ? null : curr))
        //     .min(new Date(), 'Follow-up date cannot be in the past'),
        // test_name: Yup.string().trim().required('Laboratory test is required'),
        medications: Yup.array().of(
            Yup.object().shape({
                medicine_id: Yup.string().required('Medicine selection is required'),
                dosage: Yup.string().required('Dosage is required'),
                notification_times: Yup.array()
                .of(Yup.string().required('Frequency is required'))
                .min(1, 'At least one frequency is required'),
                // start_date: Yup.date().required('Start date is required'),
                end_date: Yup.date().required('End date is required'),
                meal_time: Yup.string().required('Medicine instruction is required'),
                // notification_interval: Yup.string().required('Notification interval is required'),
                remarks: Yup.string().trim().required('Remarks note is required'),
            })
        ),
        // exercises: Yup.array().of(
        //     Yup.object().shape({
        //         workout_category: Yup.string().required('Workout category is required'),
        //         workout_time: Yup.string().required('workout time is required'),
        //         workout_duration: Yup.string().required('Workout duration is required'),
        //         workout_plan: Yup.string().required('Workout plan is required'),
        //     })
        // ),
    });

    const addMedication = () => {
        addForm.setFieldValue("medications", [
            ...addForm.values.medications,
            { medicine_id: "", dosage: "", notification_times: [], start_date: "", end_date: "", meal_time: "", remarks: "" }
            // { medicine_id: "", dosage: "", frequency: "", start_date: "", end_date: "", meal_time: "" }
            // { medicine_id: "", dosage: "", frequency: "", notification_interval: "", medicine_note: "", }
        ])
    };

    const removeMedication = (idx) => {
        const updatedMedications = addForm.values.medications.filter((med, index) => index !== idx);
        addForm.setFieldValue("medications", updatedMedications);
    };

    const addExercise = () => {
        addForm.setFieldValue("exercises", [
            ...addForm.values.exercises,
            { workout_category: "", workout_time: "", workout_duration: "", workout_plan: "" }
        ])
    };

    const removeExercise = (idx) => {
        const updatedExercises = addForm.values.exercises.filter((med, index) => index !== idx);
        addForm.setFieldValue("exercises", updatedExercises);
    };

    const addForm = useFormik({
        initialValues: {
            patient_id: "",
            // symptoms: "",
            symptoms: [],
            diagnosis_notes: "",
            past_medical_history: "",
            // investigation_advise: "",
            follow_up_date: "",
            test_name: "",
            medicine_note: "",
            // medications: [{ medicine_id: "", dosage: "", frequency: "", start_date: "", end_date: "", meal_time: "" }],
            medications: [{ medicine_id: "", dosage: "", notification_times: [], start_date: "", end_date: "", meal_time: "", remarks: "" }],
            // medications: [{ medicine_id: "", dosage: "", frequency: "", notification_interval: "", medicine_note: "" }],
            exercises: [{ workout_category: "", workout_time: "", workout_duration: "", workout_plan: "" }],
        },
        validationSchema: prescriptionValidationSchema,
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
            console.log(values?.medications, '========medincines');
            values.medications = values.medications?.map(medicine =>{
                // medicine.start_date = new Date(medicine.start_date);
                medicine.start_date = new Date();
                medicine.start_date.setHours(0, 0, 0, 0);
                medicine.end_date = new Date(medicine.end_date);
                medicine.end_date.setHours(23, 59, 59, 999);
                return medicine;
            })

            values.exercises = values.exercises?.filter(exercise => exercise.workout_category) || [];
            
            const formData = new FormData();
            formData.append("appointment_id", location.state.data?._id);
            formData.append("patient_id", location.state.data?.patient_id);
            formData.append("symptoms", JSON.stringify(values.symptoms));
            formData.append("diagnosis_notes", values.diagnosis_notes);
            formData.append("past_medical_history", values.past_medical_history);
            // formData.append("investigation_advise", values.investigation_advise);
            formData.append("follow_up_date", values.follow_up_date);
            formData.append("test_name", values.test_name);
            formData.append("medicine_note", values.medicine_note);
            formData.append("medicines", JSON.stringify(values.medications));
            formData.append("exercises", JSON.stringify(values.exercises));
            setAddSubmissionLoader(true);
            createPrescription(formData)
                .then((response) => {
                    setAddSubmissionLoader(false);
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        resetForm();
                        // setRefreshList(!refreshList);
                        navigate(`/doctor/consultation-history/1`)
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                    }
                })
                .catch((error) => {
                    setAddSubmissionLoader(false);
                    console.error("Error updating Prescription", error);
                });
        },
    });
    console.log("addForm.values------->", addForm.values);
    console.log("addForm.errors------->", addForm.errors);

    useEffect(() => {
        getAllMedicine(ROLE.DOCTOR)
            .then((data) => {
                if (data && data.data) {
                    setMedicineData(data?.data || []);
                }
            })
            .catch((error) => {
                console.log("error ====> ", error);
            });
    }, [])

    const getDateWithTimeNew = (timeString) => {
        if (!timeString) return null;
        const [hours, minutes] = timeString.split(':');
        const date = new Date();
        date.setHours(Number(hours), Number(minutes), 0, 0);
        return date;
    };

    return (
        <main id="main-content">
            <div className="inner-container">
                {/* {loader ?
                            <div className='w-100'>
                                <Skeleton circle={true} style={{ width: "96px", height: "96px" }} />
                                <Skeleton className='mt-4' style={{ height: "30px" }} />
                                <Skeleton className='mt-4' style={{ height: "30px" }} />
                                <Skeleton className='mt-4' style={{ height: "30px" }} />
                            </div>
                            : */}
                <form onSubmit={addForm.handleSubmit}>
                    {/* Personal Info Section */}
                    <div className="card">
                        <div className="card-body">
                            <div className="mb-3 card-info">
                                <h3>Personal Info</h3>
                                <p className="mb-1">#{location.state.data?.patient_register_id}</p>
                                <h4>{capitalizeFirstLetter(location.state.data?.patient_name)}</h4>
                            </div>
                            <div className="card-info-action">
                                <button
                                    className="btn btn-primary mt-2"
                                    onClick={() => {
                                        navigate(`/doctor/consultation-history/view/${location.state.data?._id}`);
                                    }}
                                >
                                    Back
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card mt-4">
                        <div className="card-body">
                            {/* <div className="mb-3">
                                <label className="form-label">
                                    {t("Chief Complaint")}
                                </label>
                                <textarea
                                    type="text"
                                    className="form-control"
                                    placeholder={t("Enter chief complaint")}
                                    name="symptoms"
                                    value={addForm.values.symptoms}
                                    onChange={addForm.handleChange}
                                    onBlur={addForm.handleBlur}
                                ></textarea>
                                {addForm.touched.symptoms && addForm.errors.symptoms && (
                                    <div className="text-danger">{addForm.errors.symptoms}</div>
                                )}
                            </div> */}
                            <ChiefComplaintInput Form={addForm} />

                            <div className="mb-3">
                                <label className="form-label">
                                    {t("Past Medical History")}
                                    {/* <span>*</span> */}
                                </label>
                                <textarea
                                    type="text"
                                    className="form-control"
                                    placeholder={t("Enter past medical history")}
                                    name="past_medical_history"
                                    value={addForm.values.past_medical_history}
                                    onChange={addForm.handleChange}
                                    onBlur={addForm.handleBlur}
                                ></textarea>
                                {addForm.touched.past_medical_history && addForm.errors.past_medical_history && <div className="text-danger">{addForm.errors.past_medical_history}</div>}
                            </div>
                            <div className="mb-3">
                                <label className="form-label">
                                    Diagnosis
                                    {/* <span>*</span> */}
                                </label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter diagnosis"
                                    name="diagnosis_notes"
                                    value={addForm.values.diagnosis_notes}
                                    onChange={addForm.handleChange}
                                    onBlur={addForm.handleBlur}
                                ></textarea>
                                {addForm.touched.diagnosis_notes && addForm.errors.diagnosis_notes && <div className="text-danger">{addForm.errors.diagnosis_notes}</div>}
                            </div>
                            {/* <div className="mb-3">
                                <label className="form-label">Investigation Advise
                                </label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter investigation advise"
                                    name="investigation_advise"
                                    value={addForm.values.investigation_advise}
                                    onChange={addForm.handleChange}
                                    onBlur={addForm.handleBlur}
                                ></textarea>
                                {addForm.touched.investigation_advise && addForm.errors.investigation_advise && (
                                    <div className="text-danger">{addForm.errors.investigation_advise}</div>
                                )}
                            </div> */}
                            <div className="add-more-medication-wrap">
                                {/* Medications Section */}
                                {addForm?.values?.medications?.map((med, index) => (
                                    <div className="" key={med.id || index}>
                                        <div className="row add-more-medication-row">
                                            {/* Medicine Name */}
                                            {/* <div className="col-md-2 add-more-medication-item">
                                                <label className="form-label">
                                                    {t("Medicine")}
                                                </label>
                                                <select className="form-control cp" name={`medications[${index}].medicine_id`} value={med.medicine_id} onChange={addForm.handleChange}>
                                                    <option value="">{t("Select")}</option>
                                                    <option value="other">{t("Other")}</option>
                                                    {medicineData?.map((item) => (
                                                        <option key={item._id} value={item._id}>
                                                            {capitalizeFirstLetter(item.name)}
                                                        </option>
                                                    ))}
                                                </select>
                                                {addForm.touched.medications?.[index]?.medicine_id && addForm.errors.medications?.[index]?.medicine_id && (
                                                    <div className="text-danger">{t(addForm.errors.medications[index].medicine_id)}</div>
                                                )}
                                            </div> */}

                                            <MedicineSelect form={addForm} index={index} />

                                            {/* Dosage */}
                                            <div className="col-md-2 add-more-medication-item">
                                                <label htmlFor="dosage" className="form-label">
                                                    {t("Dosage")}
                                                    {/* <span>*</span> */}
                                                </label>
                                                <input className="form-control" name={`medications[${index}].dosage`} placeholder="Dosage" value={med.dosage} onChange={addForm.handleChange} />
                                                {addForm.touched.medications?.[index]?.dosage && addForm.errors.medications?.[index]?.dosage && (
                                                    <div className="text-danger">{t(addForm.errors.medications[index].dosage)}</div>
                                                )}
                                            </div>

                                            {/* Frequency */}
                                            {/* <div className="col-md-3 add-more-medication-item">
                                                <label className="form-label">{t("Frequency")}<span>*</span></label>
                                                <input
                                                    className="form-control"
                                                    name={`medications[${index}].frequency`}
                                                    placeholder="Frequency"
                                                    value={med.frequency}
                                                    onChange={addForm.handleChange}
                                                />
                                                {addForm.touched.medications?.[index]?.frequency && addForm.errors.medications?.[index]?.frequency && (
                                                    <div className="text-danger">{t(addForm.errors.medications[index].frequency)}</div>
                                                )}
                                            </div> */}

                                            {/* <div className="col-md-2 add-more-medication-item">
                                                <label className="form-label">
                                                    {t("Frequency")}
                                                </label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    name={`medications[${index}].frequency`}
                                                    placeholder="Frequency"
                                                    value={med.frequency}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        addForm.setFieldValue(`medications[${index}].frequency`, value);
                                                    }}
                                                />
                                                {addForm.touched.medications?.[index]?.frequency &&
                                                    addForm.errors.medications?.[index]?.frequency && (
                                                        <div className="text-danger">
                                                            {t(addForm.errors.medications[index].frequency)}
                                                        </div>
                                                    )}
                                            </div> */}

                                            {/* Notification Interval (Hours) Dropdown */}
                                            {/* <div className="col-md-2 add-more-medication-item">
                                                <label className="form-label">{t("Frequency")}</label> */}
                                                {/* <select
                                                    className="form-control cp"
                                                    name={`medications[${index}].notification_times`}
                                                    value={med.notification_times}
                                                    onChange={e => {
                                                        const interval = e.target.value;
                                                        addForm.handleChange(e);
                                                        for (let i = 0; i < interval; i++) {
                                                            addForm.setFieldValue(`medications[${index}].notification_times[${i}]`, '');
                                                        }
                                                    }}
                                                >
                                                    <option value="">{t("Select")}</option>
                                                    {NOTIFICATION_INTERVAL?.map((item) => (
                                                        <option key={item} value={item}>
                                                            {item}
                                                        </option>
                                                    ))}
                                                </select> */}
                                                {/* <TagPicker
                                                    data={NOTIFICATION_INTERVAL}
                                                    className="form-control-tag-picker"
                                                    onChange={(e) => addForm.setFieldValue(`medications[${index}].notification_times`, e)}
                                                    cleanable={false}
                                                    value={Array.isArray(addForm.values.medications?.[index]?.notification_times) ? addForm.values.medications[index].notification_times : []}
                                                />
                                                {addForm.touched.medications?.[index]?.notification_times && addForm.errors.medications?.[index]?.notification_times && (
                                                    <div className="text-danger">{t(addForm.errors.medications[index].notification_times)}</div>
                                                )}
                                            </div> */}

                                            <div className="col-md-2 add-more-medication-item">
                                            <label className="form-label">{t("Frequency")}</label>
                                            <Whisper
                                                placement="top"
                                                trigger={
                                                Array.isArray(addForm.values.medications?.[index]?.notification_times) &&
                                                addForm.values.medications[index].notification_times.length > 0
                                                    ? "hover"
                                                    : "none"
                                                }
                                                speaker={
                                                <Tooltip>
                                                    {Array.isArray(addForm.values.medications?.[index]?.notification_times)
                                                    ? addForm.values.medications[index].notification_times.join(', ')
                                                    : "No times selected"}
                                                </Tooltip>
                                                }
                                            >
                                                <div className="tagpicker-wrapper">
                                                <TagPicker
                                                    data={NOTIFICATION_INTERVAL}
                                                    className="form-control-tag-picker custom-tag-picker"
                                                    onChange={(e) =>
                                                    addForm.setFieldValue(`medications[${index}].notification_times`, e)
                                                    }
                                                    cleanable={false}
                                                    value={
                                                    Array.isArray(addForm.values.medications?.[index]?.notification_times)
                                                        ? addForm.values.medications[index].notification_times
                                                        : []
                                                    }
                                                    renderValue={(selected, selectedItems) => {
                                                    if (!selectedItems || selectedItems.length === 0) return '';
                                                    const displayCount = 2; // Always show 2 items
                                                    const displayItems = selectedItems
                                                        .slice(0, displayCount)
                                                        .map((item) => item.label || item.value);
                                                    const remainingCount = selectedItems.length - displayCount;

                                                    return `${displayItems.join(', ')}${
                                                        remainingCount > 0 ? `, +${remainingCount} more` : ''
                                                    }`;
                                                    }}
                                                />
                                                </div>
                                            </Whisper>

                                            {addForm.touched.medications?.[index]?.notification_times &&
                                                addForm.errors.medications?.[index]?.notification_times && (
                                                <div className="text-danger">
                                                    {t(addForm.errors.medications[index].notification_times)}
                                                </div>
                                                )}
                                            </div>

                                            {/* <div className="col-md-3 add-more-medication-item">
                                                <label className="form-label"></label>
                                            </div> */}

                                            {/* Start Date */}
                                            {/* <div className="col-md-2 add-more-medication-item">
                                                <label className="form-label">
                                                    {t("Start Date")}
                                                </label>
                                                <DatePicker
                                                    oneTap={true}
                                                    classPrefix="restaurant"
                                                    placeholder={t("Enter start date")}
                                                    placement="autoVertical"
                                                    format="dd.MM.yyyy"
                                                    cleanable={false}
                                                    name={`medications[${index}].start_date`}
                                                    onChange={(e) => {
                                                        const year = e.getFullYear();
                                                        const month = String(e.getMonth() + 1).padStart(2, "0");
                                                        const date = String(e.getDate()).padStart(2, "0");
                                                        const formattedDate = `${year}-${month}-${date}`;

                                                        addForm.setFieldTouched(`medications[${index}].start_date`, true);
                                                        addForm.setFieldValue(`medications[${index}].start_date`, formattedDate);
                                                    }}
                                                    value={new Date(med.start_date)}
                                                    // onBlur={addForm.handleBlur}
                                                    // shouldDisableDate={(date) => {
                                                    //     const today = new Date();
                                                    //     today.setHours(0, 0, 0, 0);
                                                    //     return date >= today;
                                                    // }}
                                                />
                                                {addForm.touched.medications?.[index]?.start_date && addForm.errors.medications?.[index]?.start_date && (
                                                    <div className="text-danger">{t(addForm.errors.medications[index].start_date)}</div>
                                                )}
                                            </div> */}

                                            {console.log(new Date(), "==============current Date")}

                                            <div className="col-md-2 add-more-medication-item">
                                                <label className="form-label">
                                                    {t("End Date")}
                                                    {/* <span>*</span> */}  
                                                </label>
                                                <DatePicker
                                                    oneTap={true}
                                                    classPrefix="restaurant"
                                                    placeholder={t("Enter end date")}
                                                    placement="autoVertical"
                                                    format="dd.MM.yyyy"
                                                    cleanable={false}
                                                    name={`medications[${index}].end_date`}
                                                    onChange={(e) => {
                                                        const year = e.getFullYear();
                                                        const month = String(e.getMonth() + 1).padStart(2, "0");
                                                        const date = String(e.getDate()).padStart(2, "0");
                                                        const formattedDate = `${year}-${month}-${date}`;

                                                        addForm.setFieldTouched(`medications[${index}].end_date`, true);
                                                        addForm.setFieldValue(`medications[${index}].end_date`, formattedDate);
                                                    }}
                                                    value={new Date(med.end_date)}
                                                    // onBlur={addForm.handleBlur}
                                                    // shouldDisableDate={(date) => {
                                                    //     const today = new Date();
                                                    //     today.setHours(0, 0, 0, 0);
                                                    //     return date >= today;
                                                    // }}
                                                />
                                                {addForm.touched.medications?.[index]?.end_date && addForm.errors.medications?.[index]?.end_date && (
                                                    <div className="text-danger">{t(addForm.errors.medications[index].end_date)}</div>
                                                )}
                                            </div>

                                            {/* <div className="col-md-3 add-more-medication-item mt-2">
                                                <label className="form-label">{t("Choose Option")}</label>
                                                <div className="d-flex">
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            id={`beforeMeal-${index}`}
                                                            name={`medications[${index}].meal_time`} // Same name for both options
                                                            checked={med.meal_time === "before"} // Check if the value is "before"
                                                            onChange={() => {
                                                                addForm.setFieldTouched(`medications[${index}].meal_time`, true);
                                                                addForm.setFieldValue(`medications[${index}].meal_time`, "before");
                                                            }}
                                                        />
                                                        <label className="form-check-label" htmlFor={`beforeMeal-${index}`}>
                                                            {t("Before Meal")}
                                                        </label>
                                                    </div>
                                                    <div className="form-check ms-3">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            id={`afterMeal-${index}`}
                                                            name={`medications[${index}].meal_time`} // Same name for both options
                                                            checked={med.meal_time === "after"} // Check if the value is "after"
                                                            onChange={() => {
                                                                addForm.setFieldTouched(`medications[${index}].meal_time`, true);
                                                                addForm.setFieldValue(`medications[${index}].meal_time`, "after");
                                                            }}
                                                        />
                                                        <label className="form-check-label" htmlFor={`afterMeal-${index}`}>
                                                            {t("After Meal")}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div> */}

                                            <div className="col-md-2 add-more-medication-item">
                                                <label className="form-label">{t("Choose Option")}</label>
                                                <select
                                                    className="form-control"
                                                    name={`medications[${index}].meal_time`}
                                                    value={med.meal_time}
                                                    onChange={(e) => {
                                                        addForm.setFieldTouched(`medications[${index}].meal_time`, true);
                                                        addForm.setFieldValue(`medications[${index}].meal_time`, e.target.value);
                                                    }}
                                                >
                                                    <option value="">{t("Select")}</option>
                                                    {MEDICINE_OPTIONS.map((option) => (
                                                        <option value={option.value}>{option.label}</option>
                                                    ))}
                                                </select>
                                                {addForm.touched.medications?.[index]?.meal_time && addForm.errors.medications?.[index]?.meal_time && (
                                                    <div className="text-danger">{t(addForm.errors.medications[index].meal_time)}</div>
                                                )}
                                            </div>

                                            {/* Remarks */}
                                            <div className="col-md-2 add-more-medication-item">
                                                <label className="form-label">Remarks</label>
                                                <input
                                                    type="text"
                                                    name={`medications[${index}].remarks`}
                                                    value={med.remarks}
                                                    onChange={(e) => {
                                                        addForm.setFieldTouched(`medications[${index}].remarks`, true);
                                                        addForm.setFieldValue(`medications[${index}].remarks`, e.target.value);
                                                    }}
                                                    className="form-control"
                                                    placeholder="Remarks"
                                                    id={`medications[${index}].remarks`}
                                                />
                                                {addForm.touched.medications?.[index]?.remarks && addForm.errors.medications?.[index]?.remarks && (
                                                    <div className="text-danger">{t(addForm.errors.medications[index].remarks)}</div>
                                                )}
                                            </div>

                                            {/* <div className="col-md-3 add-more-medication-item">
                                                <label className="form-label"></label>
                                            </div> */}

                                            {/* <div className="col-md-3 add-more-medication-item">
                                                <label className="form-label"></label>
                                            </div>
                                            <div className="col-md-3 add-more-medication-item">
                                                <label className="form-label"></label>
                                            </div> */}

                                            {/* <div className="col-md-3 add-more-medication-item">
                                                <label className="form-label">{t("Interval(Hours)")}</label>
                                                <select
                                                    className="form-control cp"
                                                    name={`medications[${index}].notification_interval`}
                                                    value={med.notification_interval}
                                                    onChange={addForm.handleChange}
                                                >
                                                    <option value="">{t("Select")}</option>
                                                    {NOTIFICATION_INTERVAL?.map((item) => (
                                                        <option key={item} value={item}>
                                                            {item}
                                                        </option>
                                                    ))}
                                                </select>
                                                {addForm.touched.medications?.[index]?.notification_interval && addForm.errors.medications?.[index]?.notification_interval && (
                                                    <div className="text-danger">{t(addForm.errors.medications[index].notification_interval)}</div>
                                                )}
                                            </div> */}
                                            {med.medicine_id === "other" && (
                                                <div className="mt-3">
                                                    <input
                                                        className="form-control"
                                                        name={`medications[${index}].medicine_name`}
                                                        placeholder={t("Enter custom medicine name")}
                                                        value={med.medicine_id === "other" ? med.medicine_name || "" : ""}
                                                        onChange={(e) => {
                                                            addForm.setFieldValue(`medications[${index}].medicine_name`, e.target.value);
                                                            // addForm.setFieldValue(`medications[${index}].medicine_id`, "other");
                                                        }}
                                                    />
                                                    {/* {addForm.touched.medications?.[index]?.medicine_name &&
                                                        addForm.errors.medications?.[index]?.medicine_name && (
                                                            <div className="text-danger">
                                                                {t(addForm.errors.medications[index].medicine_name)}
                                                            </div>
                                                        )} */}
                                                </div>
                                            )}

                                            {/* Render input fields based on the selected interval */}
                                            {/* {med.notification_interval &&
                                                Array.from({ length: Number(med.notification_interval) }).map((_, inputIndex) => (
                                                    <div key={inputIndex} className="col-md-3 add-more-medication-item mt-2">
                                                        <label className="form-label">{t(`Interval ${inputIndex + 1} (Hours)`)}</label>
                                                        <DatePicker
                                                            classPrefix="restaurant"
                                                            placement="autoVertical"
                                                            format="HH:mm"
                                                            cleanable={false}
                                                            editable={true}
                                                            name={`medications[${index}].notification_times[${inputIndex}]`}
                                                            value={
                                                                med.notification_times?.[inputIndex]
                                                                    ? getDateWithTime(med.notification_times[inputIndex])
                                                                    : null
                                                            }
                                                            onChange={(value) => {
                                                                const formattedTime = value ? value.toTimeString().slice(0, 5) : '';
                                                                const updatedTimes = [...(med.notification_times || [])];
                                                                updatedTimes[inputIndex] = formattedTime;
                                                                addForm.setFieldValue(`medications[${index}].notification_times`, updatedTimes);
                                                            }}
                                                            onBlur={addForm.handleBlur}
                                                        />
                                                    </div>
                                                ))} */}

                                            {/* {Number(med.frequency) > 0 &&
                                                Array.from({ length: Number(med.frequency) }).map((_, inputIndex) => (
                                                    <div key={inputIndex} className="col-md-3 add-more-medication-item mt-2">
                                                        <label className="form-label">
                                                            {t(`Dosage ${inputIndex + 1} (Time)`)}
                                                        </label>
                                                        <DatePicker
                                                            classPrefix="restaurant"
                                                            placement="autoVertical"
                                                            format="HH:mm"
                                                            cleanable={false}
                                                            editable={true}
                                                            name={`medications[${index}].notification_times[${inputIndex}]`}
                                                            value={
                                                                med.notification_times?.[inputIndex]
                                                                    ? getDateWithTimeNew(med.notification_times[inputIndex])
                                                                    : null
                                                            }
                                                            onChange={(value) => {
                                                                const formattedTime = value ? value.toTimeString().slice(0, 5) : '';
                                                                const updatedTimes = [...(med.notification_times || [])];
                                                                updatedTimes[inputIndex] = formattedTime;
                                                                addForm.setFieldValue(`medications[${index}].notification_times`, updatedTimes);
                                                            }}
                                                            onBlur={addForm.handleBlur}
                                                        />
                                                    </div>
                                                ))} */}

                                            {/* <div className="col-md-12 add-more-medication-item mt-3">
                                                <label className="form-label">Medicine Note
                                                </label>
                                                <textarea
                                                    rows={2}
                                                    className="form-control"
                                                    name={`medications[${index}].medicine_note`}
                                                    placeholder="Medicine Note"
                                                    value={med.medicine_note}
                                                    onChange={addForm.handleChange}
                                                />
                                                {addForm.touched.medications?.[index]?.medicine_note && addForm.errors.medications?.[index]?.medicine_note && (
                                                    <div className="text-danger">{t(addForm.errors.medications[index].medicine_note)}</div>
                                                )}
                                            </div> */}

                                            {addForm?.values?.medications?.length > 1 && (
                                                <button type="button" className="btn btn-secondary mt-4" onClick={() => removeMedication(index)}>
                                                    ✖
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="add-more-medication-wrap mt-3">
                                <button type="button" className="link-text text-start bg-white" onClick={addMedication}>
                                    + Add More
                                </button>
                            </div>
                            <div className="mb-3 mt-3">
                                <label className="form-label">Medicine Note</label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter medicine note"
                                    name="medicine_note"
                                    value={addForm.values.medicine_note}
                                    onChange={addForm.handleChange}
                                    onBlur={addForm.handleBlur}
                                ></textarea>
                                {addForm.touched.medicine_note && addForm.errors.medicine_note && <div className="text-danger">{addForm.errors.medicine_note}</div>}
                            </div>
                            <div className="add-more-medication-wrap mt-4">
                                {/* Exercise Section */}
                                {addForm?.values?.exercises?.map((exe, index) => (
                                    <div className="" key={exe.id || index}>
                                        <div className="row add-more-medication-row">
                                            {/* Workout Category */}
                                            <div className="col-md-3 add-more-medication-item">
                                                <label className="form-label">
                                                    {t("Workout Category")}
                                                    {/* <span>*</span> */}
                                                </label>
                                                <select className="form-control cp" name={`exercises[${index}].workout_category`} value={exe.workout_category} onChange={addForm.handleChange}>
                                                    <option value="">{t("Select")}</option>
                                                    {/* <option value="">{t("Other")}</option> */}
                                                    {WORKOUT_CATEGORY.map((item) => (
                                                        <option key={item.value} value={item.value}>
                                                            {capitalizeFirstLetter(item.label)}
                                                        </option>
                                                    ))}
                                                </select>
                                                {addForm.touched.exercises?.[index]?.workout_category && addForm.errors.exercises?.[index]?.workout_category && (
                                                    <div className="text-danger">{t(addForm.errors.exercises[index].workout_category)}</div>
                                                )}
                                            </div>
                                            {/* Workout Time */}
                                            <div className="col-md-3 add-more-medication-item">
                                                <label className="form-label">
                                                    {t("Workout Time")}
                                                    {/* <span>*</span> */}
                                                </label>
                                                <DatePicker
                                                    classPrefix="restaurant"
                                                    placement="autoVertical"
                                                    format="HH:mm"
                                                    cleanable={false}
                                                    editable={true}
                                                    name={`exercises[${index}].workout_time`}
                                                    // value={exe.workout_time ? new Date(exe.workout_time) : null}
                                                    value={exe.workout_time ? new Date(`1970-01-01T${exe.workout_time}:00`) : null}
                                                    // onChange={(value) =>
                                                    //     addForm.setFieldValue(`exercises[${index}].workout_time`, value)
                                                    // }
                                                    onChange={(value) => {
                                                        const timeOnly = value ? value.toTimeString().slice(0, 5) : null; // "HH:mm"
                                                        addForm.setFieldValue(`exercises[${index}].workout_time`, timeOnly);
                                                    }}
                                                    onBlur={addForm.handleBlur}
                                                    hideMinutes={(minute) => minute % 15 !== 0}
                                                />
                                                {addForm.touched.exercises?.[index]?.workout_time && addForm.errors.exercises?.[index]?.workout_time && (
                                                    <div className="text-danger">{t(addForm.errors.exercises[index].workout_time)}</div>
                                                )}
                                            </div>
                                            {/* Workout Duration */}
                                            <div className="col-md-3 add-more-medication-item">
                                                <label htmlFor="workout_duration" className="form-label">
                                                    {t("Workout Duration(Minutes)")}
                                                    {/* <span>*</span> */}
                                                </label>
                                                <input
                                                    className="form-control"
                                                    name={`exercises[${index}].workout_duration`}
                                                    placeholder="Workout duration"
                                                    value={exe.workout_duration}
                                                    onChange={addForm.handleChange}
                                                />
                                                {addForm.touched.exercises?.[index]?.workout_duration && addForm.errors.exercises?.[index]?.workout_duration && (
                                                    <div className="text-danger">{t(addForm.errors.exercises[index].workout_duration)}</div>
                                                )}
                                            </div>
                                            <div className="col-md-3 add-more-medication-item">
                                                <label className="form-label">
                                                    {t("Workout Plan")}
                                                    {/* <span>*</span> */}
                                                </label>
                                                <select className="form-control cp" name={`exercises[${index}].workout_plan`} value={exe.workout_plan} onChange={addForm.handleChange}>
                                                    <option value="">{t("Select")}</option>
                                                    {WORKOUT_PLAN.map((item) => (
                                                        <option key={item.value} value={item.value}>
                                                            {capitalizeFirstLetter(item.label)}
                                                        </option>
                                                    ))}
                                                </select>
                                                {addForm.touched.exercises?.[index]?.workout_plan && addForm.errors.exercises?.[index]?.workout_plan && (
                                                    <div className="text-danger">{t(addForm.errors.exercises[index].workout_plan)}</div>
                                                )}
                                            </div>
                                            {addForm?.values?.exercises?.length > 1 && (
                                                <button type="button" className="btn btn-secondary mt-4" onClick={() => removeExercise(index)}>
                                                    ✖
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="add-more-medication-wrap mt-3">
                                <button type="button" className="link-text text-start bg-white" onClick={addExercise}>
                                    + Add More
                                </button>
                            </div>
                            {/* <div className='card mt-4'> */}
                            {/* <div className='card-body'> */}
                            <div className="mb-3 mt-4">
                                <label className="form-label" style={{ color: "#212121", fontWeight: 800 }}>
                                    {t("Follow Up Date")}
                                    {/* <span>*</span> */}
                                </label>
                                <DatePicker
                                    oneTap={true}
                                    classPrefix="restaurant"
                                    placeholder={t("Enter follow up date")}
                                    placement="autoVertical"
                                    format="dd.MM.yyyy"
                                    cleanable={false}
                                    name="follow_up_date"
                                    onChange={(e) => {
                                        addForm.setFieldTouched("follow_up_date", true);
                                        addForm.setFieldValue("follow_up_date", e);
                                    }}
                                    value={new Date(addForm.values.follow_up_date)}
                                    onBlur={addForm.handleBlur}
                                />
                                {addForm.touched.follow_up_date && addForm.errors.follow_up_date && <div className="text-danger">{addForm.errors.follow_up_date}</div>}
                            </div>
                            <div className="mb-3">
                                <label className="form-label" style={{ color: "#212121", fontWeight: 800 }}>
                                    Diagnosis Test
                                    {/* <span>*</span> */}
                                </label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter laboratory test"
                                    name="test_name"
                                    value={addForm.values.test_name}
                                    onChange={addForm.handleChange}
                                    onBlur={addForm.handleBlur}
                                ></textarea>
                                {addForm.touched.test_name && addForm.errors.test_name && <div className="text-danger">{addForm.errors.test_name}</div>}
                            </div>
                            {/* </div> */}
                            {/* </div> */}
                            <div className="d-flex justify-content-start gap-2 mt-4">
                                <button type="submit" className={`btn btn-primary${addSubmissionLoader ? " btn-loader" : ""}`}>
                                    Create
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
                {/* } */}
            </div>
        </main>
    );
}
